export const general = {
}
